<div id="wrapper">
    <div>
        <app-menu [tabActive]="this.tabActive" [showUserMobile]="this.global.showUserMobile"></app-menu>
    </div>
    <div>
        <app-tab-nav [visible]="false" 
            (updateType)="this.type=$event"    
            (updatePostpaid)="this.postpago=$event" (updatePrepaid)="this.prepago=$event"
            (updateFixed)="this.telefoniaFijo=$event" (updateTotalAccountList)="this.totalAccountList=$event"
            (updateCurrentList)="this.currentList=$event" (updateSelectBan)="this.selectBan=$event"
            (updateInitializeData)="this.initializeData()">
        </app-tab-nav>
    </div>
    <div class="allcont logsize ajusteTop1">
        <div *ngIf="this.screenView==1">
            <div class="refbgmdl">
                <div class="basicrow f-refdef">
                    <div class="texto-ref">
                        Refiere y Gana
                        <img width="100%" src="../../../assets/images/refgiftimg.png">
                    </div>
                </div>
                <div class="basicrow f-med roboto-r m-top">
                    <div class="row">
                    </div>
                </div>
                <div class="basicrow m-top-i">
                    <div class="row">
                        <div class="caja-email">
                            <div class="basicrow rel">
                                <input [(ngModel)]="this.emailReciever" class="inp-f" type="text" value=""
                                    data-role="tagsinput" id="tags"
                                    placeholder="Ingrese Correos Electrónicos. Ejemplo: n/a@gmail.com; n/a@yahoo.com; n/a@hotmail.com">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="basicrow m-top-i boton">
                    <a (click)="this.inviteFriends()" class="btns centr red refbtn vcenter">
                        <span class="tabcell">
                            Invitar a tus amigos
                        </span>
                    </a>
                </div>
            </div>
            <div class="basicrow">
                <div class="basicrow f-black f-big roboto-r text-center m-top-i">
                    Otras maneras de compartir
                </div>
                <div class="basicrow m-top text-center">

                    <span *ngFor="let socialMedia of this.socialMedia; let n = i">
                        <span *ngIf="socialMedia.socialMedia=='email'">
                            <a (click)="this.share(socialMedia.socialMedia)" class="refsocials mailng">
                                <i class="fa fa-envelope" aria-hidden="true"></i>
                            </a>
                        </span>
                        <span *ngIf="socialMedia.socialMedia=='facebook'">
                            <a (click)="this.share(socialMedia.socialMedia)" class="refsocials fcbook">
                                <i class="fa fa-facebook-square face" aria-hidden="true"></i>
                            </a>
                        </span>
                        <span *ngIf="socialMedia.socialMedia=='twitter'">
                            <a (click)="this.share(socialMedia.socialMedia)" class="refsocials twtt">
                                <i class="fa fa-twitter" aria-hidden="true"></i>
                            </a>
                        </span>
                    </span>
                    <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>
                </div>
                <div class="basicrow m-top text-center">
                    <div class="reflinkdef">
                        <div id="inter1" class="inter1" style="overflow: hidden;height: 22px;">
                            {{this.link}}
                            <i *ngIf="this.checkTerms==true" (click)="this.copyLink()" class="fa fa-copy copyIconI"
                                style="color: #d6d6d7;font-size: 1.8em;position: absolute;top: 0%;bottom: 0;right: 15px;margin: auto;cursor: pointer;"
                                class="fa fa-copy"></i>
                        </div>
                    </div>
                </div>
                <div class="basicrow roboto-r text-center m-top">
                    <input type="checkbox" [(ngModel)]="this.checkTerms" (checked)="this.checkTerms" (click)="this.termsCheckboxSelected();" style="cursor: pointer; margin-right: 10px;">
                    <a (click)="this.mostarTerminos();" class="linkdefs reftermlink"> 
                        T&eacute;rminos y condiciones de la promoci&oacute;n <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                    </a>
                </div>
            </div>
            <div class="basicrow bg-gray-i m-top-i ">
                <div class="basicrow">
                    <div class="basicrow f-btitle f-black text-center">
                        Descuento por Referidos
                    </div>
                    <div class="basicrow">
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8 col-md-offset-2 col-lg-offset-2">
                                <div class="row vista-datos">
                                    <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4 m-top-i">
                                        <div class="basicrow f-black roboto-b text-center">
                                            <span *ngIf="!this.hasProcentageAsReferer" class="f-lsemi f-blue">
                                                {{ this.TotalAvailable }}
                                            </span>
                                            <span *ngIf="this.hasProcentageAsReferer" class="f-lsemi f-blue">
                                                {{ this.countProcentageAsReferer }}%
                                            </span>
                                            <br /><br />
                                            <span class="f-bmed">
                                                Descuentos Disponibles
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4 m-top-i">
                                        <div class="basicrow f-black roboto-b text-center">
                                            <span class="f-lsemi f-red">
                                                {{this.totalReferer}}
                                            </span><br /><br />
                                            <span class="f-bmed">
                                                Amigos Referidos
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4 m-top-i">
                                        <div class="basicrow f-black roboto-b text-center">
                                            <span class="f-lsemi f-red">
                                                {{this.totalRedeem}}
                                            </span><br /><br />
                                            <span class="f-bmed">
                                                Amigos Redimidos
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="basicrow text-center" style="padding-top: 30px;padding-bottom: 0px !important;">
                <img style="font-size: 4em;cursor: pointer;width: auto;height: 90px;"
                    src="../../../assets/images/ico_preguntasFrecuentes.png" alt="icono_questions"
                    (click)="this.mostrarPreguntasFrecuentes()">
            </div>
            <div class="basicrow f-black roboto-l text-justify m-top">
                <div class="basicrow f-mildt text-center" style="cursor: pointer;"
                    (click)="this.mostrarPreguntasFrecuentes()">
                    Preguntas Frecuentes
                </div>
                <div class="f-reg roboto-r f-black basicrow m-top">
                </div>
            </div>
        </div>
        <div class="container" *ngIf="this.screenView==2">
            <app-referred-frequent-questions (updatescreenview)="this.screenView=$event">
            </app-referred-frequent-questions>
        </div>
    </div>
    <app-footer></app-footer>
</div>